module.exports = __webpack_public_path__ + "assets/img/bf.41bffcdf.jpg";